import React from 'react';
import { Navigate, createBrowserRouter } from 'react-router-dom';
import ErrorPage from '@/pages/ErrorPage';
import { protectedRoutes } from './ProtectedRoutes';
import { publicRoutes } from './PublicRoutes';

export const router = createBrowserRouter([
  {
    path: '/',
    errorElement: React.createElement(ErrorPage),
    children: [
      ...publicRoutes,
      protectedRoutes,
      {
        path: '*',
        element: React.createElement(Navigate, {
          to: '/home',
          replace: true,
        }),
      },
    ],
  },
]);
